import React from 'react';
import './Btn3.css';
import btnImg from '../../asserts/btn3.png';
import { useMusic } from '../layout/MusicContext';

const Btn3 = ({ onClick }) => {
  const { playClick } = useMusic();
  const handleClick = (e) => {
    playClick();
    if (onClick) onClick(e);
  };
  return (
    <button className="btn3" onClick={handleClick}>
      <img className="btn3-bg" src={btnImg} alt="" />
      <span className="btn3-text">Back</span>
    </button>
  );
};

export default Btn3;